<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="storm-clouds">
<p style="margin-top: 250px; text-align: center;">“We may have all come on different ships, but we’re in the same boat now.”</p><br/>
<p style="text-align: right;">Martin Luther King</p>
<p style="text-align: right;">August 28, 1963</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?2ce3ec26